(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('EventsListController', EventsListController);

    /** @ngInject */
    function EventsListController($scope, $state, $stateParams, $rootScope, EventService, AuthenticationService, HelperService, DATA_EVENTS) {
        const vm = this;

        let eventsPerPage;
        let eventsSkip;
        let forcePaginationReset;
        let isTableSearch;

        vm.isSearchDisabled = () => {
            if (vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;
                isTableSearch = true;

                vm.getPaginatedEvents({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
            vm.searchText = '';

            if (isTableSearch) {
                vm.getPaginatedEvents({
                    page: vm.currentPage
                });

                isTableSearch = false;
            }
        }

        vm.getPaginatedEvents = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset) {
                vm.currentPage = 1;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            eventsSkip = (vm.currentPage - 1) * eventsPerPage;

            getEvents();
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getEvents() {
            HelperService.startLoading('.events-holder');

            vm.events = [];
            vm.isLoading = true;

            const parameters = prepareParameters();
            let userData = AuthenticationService.getUserData();

            parameters.ResponsibilityId = userData.Responsibility.Id;

            EventService
                .getAllByParameters(parameters, userData.Id)
                .then(success => {
                    vm.events = success.Events;
                    vm.numberOfPages = success.NumberOfPages;
                    vm.isLoading = false;

                    $state.go('app-master.default.events', {
                        eventPage: vm.currentPage
                    });

                    HelperService.stopLoading('.events-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters() {
            let params = {
                PerPage: eventsPerPage,
                Skip: eventsSkip,
                OrderBy: 'StartDate',
                OrderDescending: false,
                Active: true,
                StartDate: moment().format()
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
            }

            return params;
        }

        function initVars() {
            eventsPerPage = 5;
            eventsSkip = 0;
            forcePaginationReset = false;
            isTableSearch = false;

            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.eventPage)) {
                $state.go('app-master.default.events', {
                    eventPage: 1
                });
            } else
                vm.currentPage = $stateParams.eventPage;

            vm.events = [];
            vm.isLoading = false;

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Amanhã': [
                            moment().add(1, 'days'),
                            moment().add(1, 'days')
                        ],
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ]
                    },
                    'eventHandlers': {
                        'cancel.daterangepicker': (ev, picker) => {
                            vm.datePicker.date = {
                                startDate: null,
                                endDate: null
                            };
                        }
                    }
                }
            }
        }

        function init() {
            initVars();

            vm.getPaginatedEvents({
                page: vm.currentPage
            });
        }
    }
}());